export const riskMitigationTableHeaders = [
  {
    field: "Category",
    customClass: "w-3/12 pl-2",
  },
  {
    field: "SubCategory",
    customClass: "w-3/12",
  },
  {
    field: "Title",
    customClass: "w-3/12",
  },
  {
    field: "Description",
    customClass: "w-2/12",
  },
  {
    field: "Actions",
    customClass: "w-1/12 ",
  },
]